import { render, staticRenderFns } from "./MiniTable.vue?vue&type=template&id=99de4276&scoped=true&"
import script from "./MiniTable.vue?vue&type=script&lang=js&"
export * from "./MiniTable.vue?vue&type=script&lang=js&"
import style0 from "./MiniTable.vue?vue&type=style&index=0&id=99de4276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99de4276",
  null
  
)

export default component.exports